var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.activity.actor === "visitor"
        ? [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("notification.chatOpenedByVisitor", {
                    visitor: _vm.getVisitorName,
                    platform: _vm.$_.get(_vm.activity, "payload.ref"),
                  })
                ),
              },
            }),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.activity.actor === "user"
        ? [
            _c("span", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("notification.chatOpenedByAgent", {
                    agent: _vm.$_.get(_vm.activity, "actorUser.name"),
                    visitor: _vm.$_.get(_vm.activity, "refVisitor.fullname"),
                    platform: _vm.$_.get(_vm.activity, "payload.ref"),
                  })
                ),
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }